<app-confirm-reject-button class="mr-1" [confirm]="activated"></app-confirm-reject-button>
{{ activationCode }}